import ComplementRepository from "@/repositories/tuevs/ComplementRepository";
import makeState from "@/storages/Base/State";
import makeGetters from "@/storages/Base/Getters";
import makeMutations from "@/storages/Base/Mutations";
import makeActions from "@/storages/Base/Actions";

export default {
    name: 'complement',
    namespaced: true,
    state: makeState(),
    getters: makeGetters(),
    mutations: makeMutations(),
    actions: {
        ...makeActions(ComplementRepository),
        async listOne ({ commit, state }, id) {
            commit('setLoading', true)
            await ComplementRepository.fetch(id).then(response => {
                commit('setCurrent', response.data.data.complement)
            })
            commit('setLoading', false)
        },
        async listAll ({ commit, state }, params) {
            commit('setLoading', true)
            await ComplementRepository.fetchAll(params).then(response => {
                commit('setAll', response.data.data)
                commit('setPagination', {
                    ...state.pagination,
                    total: response.data.total
                })
            })
            commit('setLoading', false)
        }
    }
}
